export default {"src":"/_next/static/media/idea.c8f80176.svg","height":52,"width":52};